export default {
  title: 'Major Management',
  menu: 'Major Management',
  label: {
    majorChineseName: 'Major Chinese Name',
    majorEnglishName: 'Major English Name',
    reviewStatus: 'Review Status',
    edit: 'Edit',
    addMajor: 'Add Major',
    editMajor: 'Edit Major',
    mergeTo: 'Merge to'
  },
  reviewStatus: {
    yes: 'Yes',
    no: 'No'
  },
  placeholder: {
    keywords: 'Search major Chinese name',
    pleaseStartTyping: 'Please Start Input'
  },
  message: {
    saveSuccess: 'Save Success',
    saveFail: 'Save Fail'
  }
}
